import { initDriverActivityChart } from "./initDriverActivityChart";

export const driverActivityChart = {
  initDriverActivityChart,
};
